import { $ } from '@/Engine/state';

export const changeTexture = function(item, newTex, slotName = 'face_texture.jpg') {
    for (let name in item.material.nodeTextures) {
        if (item.material.nodeTextures[name].name === slotName) {
            if (slotName === 'face_texture.jpg' || 'back_texture') {
                newTex.encoding = v3d.__faceTexture.encoding;
                newTex.wrapS = v3d.__faceTexture.wrapS;
                newTex.wrapT = v3d.__faceTexture.wrapT;
                newTex.anisotropy = v3d.__faceTexture.anisotropy;
            }
            // else if (slotName === 'back_texture') {
            //     newTex.encoding = v3d.__backText.encoding;
            //     newTex.wrapS = v3d.__backText.wrapS;
            //     newTex.wrapT = v3d.__backText.wrapT;
            //     newTex.anisotropy = v3d.__backText.anisotropy;
            // }
           // newTex.name = slotName

            item.material.nodeTextures[name] = newTex;
        }
    }
    item.material.needsUpdate = true;
};


export const changeTextureCustom = function(material, oldName, newTex) {
    if (!material) {
        console.warn('В модели нет material');
        return;
    }
    if (!material.nodeTextures) {
        console.warn('В материале нет nodeTextures');
        return;
    }
    for (let name in material.nodeTextures) {
        // console.log(material.nodeTextures[name].name, oldName);
        if (material.nodeTextures[name].name.includes(oldName)) {
            newTex.flipY = false;
            newTex.encoding = material.nodeTextures[name].encoding;
            newTex.wrapS = material.nodeTextures[name].wrapS;
            newTex.wrapT = material.nodeTextures[name].wrapT;
            newTex.anisotropy = material.nodeTextures[name].anisotropy;
            material.nodeTextures[name] = newTex;
            material.nodeTextures[name].name = oldName;
            material.nodeTextures[name].needsUpdate = true;
            break;
        }
    }
    material.needsUpdate = true;
    $.render();
};
